/**
 * Created by mzietek on 2016-11-24.
 */

/**
 * Created by mzietek on 2016-11-23.
 */

/**
 * Created by mzietek on 2016-11-18.
 */

(function (angular) {
    'use strict';

    angular
        .module("repairforms.constant.module")
        .constant("CivilityModel", CivilityModel());

    CivilityModel.$inject = ['$filter'];

    function CivilityModel($filter) {

        return {
            getOptionsArray : getOptionsArray,
            getDisplayValue : getDisplayValue
        };

        function getOptionsArray() {
            return [
                {
                    dbValue: 'MR',
                    displayValue: 'Mr'
                },
                {
                    dbValue: 'MS',
                    displayValue: 'Ms'
                },
                {
                    dbValue: 'MRS',
                    displayValue: 'Mrs'
                }
            ];
        }

        function getDisplayValue(dbValue) {
            var options = getOptionsArray();
            for(var i = 0; i < options.length; ++i) {
                if(options[i].dbValue == dbValue) {
                    return options[i].displayValue;
                }
            }
            return '';
        }
    }

})(angular);